/* eslint-disable @next/next/no-before-interactive-script-outside-document */
import Script from 'next/script'
import { initCookiesBlocker } from '../service'
import { getConfig } from '@/tools/config'
import { createGlovoError } from '@/tools/error-handling'
import { useLocalisation } from '@/tools/i18n/client'
import { glovoRum } from '@/tools/o11y/client'

export function InjectCookieScripts() {
  const { userCentricsScriptId } = getConfig()
  const { getLanguage } = useLocalisation()
  const currentLanguage = getLanguage()

  const handleScriptLoad = () => {
    glovoRum.addAction('cookie_consent.init', {})
    try {
      void initCookiesBlocker()
      glovoRum.addAction('cookie_consent.init.success', {})
    } catch (e) {
      glovoRum.addAction('cookie_consent.init.error', {})
      throw e instanceof Error
        ? e
        : createGlovoError('[CookieConsent] Unknown init error', { context: 'cookie_consent.init' })
    }
  }

  const handleScriptError = () => {
    // Track these errors as an action, to prevent noise.
    // Browser or extension blocking the script, is not something actionable so has no value
    // to track them as errors.
    glovoRum.addAction('cookie_consent.init.script_load.error', {})
  }

  return (
    <Script
      async
      data-language={currentLanguage}
      data-settings-id={userCentricsScriptId}
      id="usercentrics-cmp"
      src="https://web.cmp.usercentrics.eu/ui/loader.js"
      onError={handleScriptError}
      onLoad={handleScriptLoad}
    />
  )
}
